import { ColDef, ColumnPinnedType } from 'ag-grid-enterprise';
import { APIComponentAttributes, ArdoqId } from '@ardoq/api-types';
import { DeleteComponentButton } from '../CellRenderers/cellRenderers';
import { ComponentCellRendererProps } from '../CellRenderers/types';
import { ArtificialColumnDefinitionArdoqMetadata } from '../types';

export const deleteComponentColumnId = 'delete-component-action';

export const getDeleteColumnDefinition = (
  nameColumnPinned: ColumnPinnedType
): ColDef<APIComponentAttributes> => {
  return {
    headerName: '',
    colId: deleteComponentColumnId,
    sortable: false,
    suppressColumnsToolPanel: true,
    suppressNavigable: false,
    suppressHeaderMenuButton: true,
    suppressMovable: true,
    suppressFillHandle: true,
    pinned: nameColumnPinned,
    filter: false,
    suppressSizeToFit: true,
    width: 50,
    maxWidth: 50,
    minWidth: 50,
    context: {
      inventoryColumnType: 'artificial',
    } satisfies ArtificialColumnDefinitionArdoqMetadata,
    cellRenderer: (params: ComponentCellRendererProps<ArdoqId>) => {
      const deleteRow = () => {
        if (params.node && params.data) {
          params.api.applyTransaction({ remove: [params.data] });
        }
      };

      return <DeleteComponentButton onClick={deleteRow} {...params} />;
    },
  };
};
